import { useMutation } from '@tanstack/react-query';

import { callPost } from '@/api/fetcher';
import { AmendPayload } from '@/shared/types/tryIt';

type CorrectionBody = { correction: string } & AmendPayload;

const sendCorrectionRequest = (body: CorrectionBody): Promise<{ status: string }> => {
  if (body.simulation) {
    const { brain_id, run_id, evaluation_id } = body.simulation;
    const path = `/www/api/v1/brains/${brain_id}/simulations/runs/${run_id}/evaluations/${evaluation_id}/corrections`;
    return callPost(path, { request_id: body.request_id, correction: body.correction });
  }
  return callPost('/www/api/v1/brains/corrections', { ...body, timestamp: Date.now() });
};

export const useSendCorrection = () => {
  const mutation = useMutation<{ status: string }, Error, CorrectionBody>({
    mutationFn: sendCorrectionRequest,
    meta: { errorToast: true },
  });
  return { sendCorrection: mutation.mutateAsync, isPending: mutation.isPending };
};
